import React from "react";
import PropTypes from "prop-types";

import { rhythm } from "../../utils/typography";

// eslint-disable-next-line react/prop-types
const Time = ({ date }) => <time
    className="displayBlock"
    style={{
      fontSize: rhythm(2.75 / 5),
      marginTop: rhythm(-1.5 / 2),
      marginBottom: rhythm(1 / 2)
    }}
    dateTime={new Date(date).toISOString()}
  >
    {date}
  </time>;

Time.propTypes = { date: PropTypes.string.isRequired };

export default Time;



// WEBPACK FOOTER //
// ./src/components/Time/index.jsx